/** Query params for GET /statuses listing */
export const buildStatusListParams = ({
  page = 1,
  perPage = 10,
  search = '',
  model = '',
} = {}) => ({
  page,
  per_page: perPage,
  paginate: 1,
  ...(search ? { search } : {}),
  ...(model ? { 'conditions[model]': model } : {}),
});

/** FormData for POST /statuses (multipart form-data) */
export const buildStatusFormData = ({ model, name, color, icon }) => {
  const fd = new FormData();
  fd.append('model', (model || '').trim());
  fd.append('name', (name || '').trim());
  if (color != null && String(color).trim() !== '') {
    fd.append('color', String(color).trim());
  }
  if (icon != null && String(icon).trim() !== '') {
    fd.append('icon', String(icon).trim());
  }
  return fd;
};

/** Common status models used across the CRM */
export const STATUS_MODEL_OPTIONS = [
  'Lead',
  'User',
  'Customer',
  'Equipment',
  'Task',
  'TaskUser',
  'TaskCategory',
  'TaskType',
  'Company',
  'Service',
  'payment',
  'CallRecord',
  'Issue',
  'Meeting',
  'ImportBusiness',
  'dba',
];
